import { render, staticRenderFns } from "./GSTStatus.vue?vue&type=template&id=31a5de1c&"
import script from "./GSTStatus.vue?vue&type=script&lang=js&"
export * from "./GSTStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports